import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TextChanges } from './text-changes';
import { Courts } from './courts/Courts';
import { Magistrates } from './magistrates/Magistrates';
import { TransactionGroupList } from './transactiongroups/TransactionGroupList';
import { TransactionGroupEdit } from './transactiongroups/TransactionGroupEdit';
import { TransactionKeyList } from './transactionkeys/TransactionKeyList';
import { TransactionKeyEdit } from './transactionkeys/TransactionKeyEdit';
import { ActionCostList } from './actioncosts/ActionCostList';
import { ActionCostEdit } from './actioncosts/ActionCostEdit';

import { AgreementList } from './agreements/AgreementList';
import { AgreementCreate } from './agreements/AgreementCreate';
import { AgreementEdit } from './agreements/AgreementEdit';
import { AgreementToContractEdit } from './agreements/AgreementToContractEdit';

import { LabelsList } from './labels/LabelsList';
import { LabelsEdit } from './labels/LabelsEdit';

import { CollectionFeeList } from './collectionfees/CollectionFeeList';
import { CollectionFeeEdit } from './collectionfees/CollectionFeeEdit';
import { FormList } from './forms/FormList';
import { FormEdit } from './forms/FormEdit';
import { SettingList } from './settings/SettingList';
import { TableTypeList } from './tables/TableTypeList';
import { TableList } from './tables/TableList';
import { TableEdit } from './tables/TableEdit';
import { TableRateList } from './tables/TableRateList';
import { TableRateEdit } from './tables/TableRateEdit';
import { ClaimTypeList } from './claims/ClaimTypeList';
import { ClaimTypeEdit } from './claims/ClaimTypeEdit';
import { LINFileImport } from './imports/LINFileImport';
import { HeimavellirFileImport } from './imports/HeimavellirFileImport';


import { ReturnReport } from './exports/ReturnReport';
import { ReturnTermReport } from './exports/ReturnTermReport';
import { ReturnSumTermReport } from './exports/ReturnSumTermReport';
import { OutlaidCostStatusReport } from './exports/OutlaidCostStatusReport';
import { SettledClaimReport } from './exports/SettledClaimReport';

import { ActionTextList } from './actiontexts/ActionTextList';
import { ActionDiaryTextList } from './actiondiarytexts/ActionDiaryTextList';

import { OutlaidCostReport } from './exports/OutlaidCostReport';
import { DefaultDebtorRegistryOverview } from './defaultdebtorregistry/DefaultDebtorRegistryOverivew';
import ErrorBox from '../components/messages/ErrorBox';
import { AdminCatalog } from './AdminCatalog';
import { CommandList } from './jobs/CommandList';
import { JobList } from './jobs/JobList';
import { MessageList } from './jobs/MessageList';

import { CacheList } from './cache/CacheList';






export const AdminRouter = () => {  
  return (    
        <ErrorBox>          
          <Switch>      
            <Route exact path="/admin" component={AdminCatalog} />
            <Route path="/admin/text-changes" component={TextChanges} />
            <Route exact path="/admin/settings" component={SettingList} />
            <Route exact path="/admin/forms" component={FormList} />
            <Route path="/admin/forms/edit" component={FormEdit} />          
            <Route path="/admin/courts" component={Courts} />
            <Route path="/admin/magistrates" component={Magistrates} />
            <Route exact path="/admin/transactiongroups" component={TransactionGroupList} />
            <Route path="/admin/transactiongroups/edit" component={TransactionGroupEdit} />
            <Route exact path="/admin/transactionkeys" component={TransactionKeyList} />
            <Route path="/admin/transactionkeys/edit" component={TransactionKeyEdit} />
            <Route exact path="/admin/actioncosts" component={ActionCostList} />
            <Route path="/admin/actioncosts/edit" component={ActionCostEdit} />    
            <Route exact path="/admin/collectionfees" component={CollectionFeeList} />
            <Route path="/admin/collectionfees/edit" component={CollectionFeeEdit} />   
            
            <Route exact path="/admin/agreements" component={AgreementList} />
            <Route exact path="/admin/agreements/create" component={AgreementCreate} /> 
            <Route exact path="/admin/agreements/edit" component={AgreementEdit} />  
            <Route exact path="/admin/agreements/connect" component={AgreementToContractEdit} />    

             <Route exact path="/admin/labels" component={LabelsList} />
             <Route exact path="/admin/labels/edit" component={LabelsEdit} />              
            
            <Route exact path="/admin/tabletypes" component={TableTypeList} />            
            <Route exact path="/admin/tables" component={TableList} />
            <Route path="/admin/tables/edit" component={TableEdit} />               
            <Route exact path="/admin/tablerates" component={TableRateList} />               
            <Route path="/admin/tablerates/edit" component={TableRateEdit} />               

            <Route exact path="/admin/claimtypes" component={ClaimTypeList} />
            <Route exact path="/admin/claimtypes/edit" component={ClaimTypeEdit} />
            
            <Route path="/admin/defaultdebtorregistryoverivew" component={DefaultDebtorRegistryOverview} />         
            <Route exact path="/admin/imports/lin" component={LINFileImport} />   
            <Route exact path="/admin/imports/heimavellir" component={HeimavellirFileImport} />   
            <Route exact path="/admin/exports/return" component={ReturnReport} />             
            <Route exact path="/admin/exports/returnterm" component={ReturnTermReport} />             
            <Route exact path="/admin/exports/returnsumterm" component={ReturnSumTermReport} />              
            <Route exact path="/admin/exports/outlaidcost" component={OutlaidCostReport} />             
            <Route exact path="/admin/exports/settledclaims" component={SettledClaimReport} />    

            <Route exact path="/admin/actiontexts" component={ActionTextList} />    
            <Route exact path="/admin/actiontexts/diary" component={ActionDiaryTextList} />        

            <Route exact path="/admin/exports/outlaidcoststatus" component={OutlaidCostStatusReport} />
            


            <Route path="/admin/jobs/commands" component={CommandList} />
            <Route path="/admin/jobs/runs" component={JobList} />
            <Route path="/admin/jobs/messages" component={MessageList} />

            <Route exact path="/admin/cache" component={CacheList} />

            

          </Switch>
        </ErrorBox>    
  );
};

